import { createApi } from '@reduxjs/toolkit/query/react';
import { authContactType } from '@store/rtk/types';
import { idType, selectItemType } from '@src/types';
import { baseQuerySample } from '@store/helpers';
import { DEFAULT_PAGE_SIZE } from '@src/utils/constants';

export type surveyType = {
  sendingDate: string;
  effectiveDate: string;
  expirationDate: string;
  template: selectItemType | null;
  methodVerified: selectItemType | null;
  signatureRequiredIndicator: boolean;
  memberId: number;
  status: selectItemType | null;
  documentId: number;
  sentToAuthorizedContactRecordId: number;
  authorizedContact: authContactType;
};

export const documentsApi = createApi({
  reducerPath: 'Documents',
  tagTypes: ['Documents'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getSurveys: builder.mutation({
      query: ({ body = {}, params = {} }) => ({
        url: `/v1/member/surveys/member`,
        method: 'POST',
        body,
        params: {
          sortBy: 'expirationDate',
          sortDir: 'desc',
          page: 0,
          size: DEFAULT_PAGE_SIZE,
          ...params,
        },
      }),
    }),
    getSurveyById: builder.query<surveyType, { id: idType }>({
      query: ({ id }) => ({
        url: `/v1/member/surveys/${id}`,
      }),
    }),
    getPhysicianCertification: builder.mutation({
      query: ({
        page,
        size,
        body = {},
        params = { sortBy: 'expirationDate', sortDir: 'desc' },
      }) => ({
        url: `/v1/member/physician-certificate/member?page=${page}&size=${size}`,
        method: 'POST',
        body,
        params,
      }),
    }),
    getPhysicianCertificationByID: builder.query({
      query: ({ id }) => ({
        url: `/v1/member/physician-certificate/${id}`,
      }),
    }),
    getSurveyTemplate: builder.query({
      query: ({ params = {} }) => ({
        url: `/v1/users/survey-templates`,
        params: {
          sortBy: 'id',
          sortDir: 'desc',
          page: 0,
          size: DEFAULT_PAGE_SIZE,
          ...params,
        },
      }),
    }),
    getSurveyTemplateById: builder.query({
      query: ({ id }) => ({
        url: `/v1/users/survey-templates/${id}`,
      }),
    }),
    createOrUpdatePhysician: builder.mutation({
      query: ({ id, data }) => ({
        url: `/v1/member/physician-certificate/${id ? `update/${id}` : 'create'}`,
        method: id ? 'PUT' : 'POST',
        body: data,
      }),
    }),
    createOrUpdateSurveys: builder.mutation({
      query: ({ data, pathname, method }) => ({
        url: `${pathname}`,
        method: method,
        body: data,
      }),
    }),
    getFileUrl: builder.query({
      query: ({ fileContainerName, pathname }) => ({
        url: `/v1/documents/images/${fileContainerName}/${pathname}
 `,
      }),
    }),
  }),
});

export const {
  useCreateOrUpdatePhysicianMutation,
  useCreateOrUpdateSurveysMutation,
  //FIXME: if not use in future, delete it
  // useGetDocumentsQuery,
  // useUpdateDocumentsMutation,
  useGetSurveysMutation,
  useLazyGetPhysicianCertificationByIDQuery,
  useLazyGetSurveyByIdQuery,
  useGetPhysicianCertificationMutation,
  useLazyGetSurveyTemplateQuery,
  useLazyGetSurveyTemplateByIdQuery,
  useLazyGetFileUrlQuery,
} = documentsApi;
